import { useTranslation } from "react-i18next";
import man2 from "../assests/solutions/Man-2.webp";
import { FiEye, FiAlertTriangle, FiCheckSquare, FiSettings, FiBarChart2, FiTrendingUp } from "react-icons/fi";
import Approach from "./Approach";
import bg from "../assests/solutions/App.webp"
import './Manufacturing.css'
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
const Manufacturing = () => {

    const { i18n } = useTranslation();
    const isArabic = i18n.language === "ar";
    const approachItems = [
        {
            step: 1,
            title: "Business Understanding",
            description: "Understanding business and its processes to deliver the right solution",
        },
        {
            step: 2,
            title: "Requirement Elicitation",
            description: "Gather requirements to provide the best solution",
        },
        {
            step: 3,
            title: "Design Thinking",
            description: "Ideate and develop the best ways to fulfil the requirements",
        },
        {
            step: 4,
            title: "Workshop",
            description: "Conducting detailed workshops to identify gaps and overcome bottlenecks",
        },
        {
            step: 5,
            title: "Deployment",
            description: "Utilize best practices and seamlessly deploy the solution",
        },

    ];

    return (
        <>
            <div className="hd">
                <Header />
            </div>
            <section
                className="man-info-bg"
                // style={{
                //     backgroundImage: `url(${man1})`
                // }}


            >
                {/* <div className="man-info-overlay" /> */}

                <div className="main-hero-content" data-aos="fade-up" style={{ paddingLeft: isArabic ? "0px" : "70px", paddingRight: isArabic ? "70px" : "0px" }}>
                    <h1 className="main-title" style={{color: "black"}}>
                        Manufacturing Execution
                    </h1>

                    <p className="main-subtitle">
                        Optimizing productivity and delivering manufacturing excellence


                    </p>
                </div>

            </section>

            <section
                className="cloud-info-bg"
                style={{
                    backgroundImage: `url(${isArabic ? man2 : man2})`
                }}
            >
                <div className="cloud-info-overlay" />

                <div className="cloud-info-content" data-aos="fade-up" style={{ paddingLeft: isArabic ? "0px" : "70px", paddingRight: isArabic ? "70px" : "0px" }}>
                    <p>Today’s manufacturing industry is rapidly evolving and undergoing digital transformation. This fast-paced manufacturing environment requires accurate and real-time data from the shop floors to optimize production processes, improve efficiency and enhance business performance. </p>
                    <p>A Manufacturing Execution System (MES) is a comprehensive software that monitors and controls complex manufacturing processes. It is used to ensure effective planning and execution of manufacturing processes and improvement in overall production efficiency</p>
                </div>
            </section>

            <section className="manufacturing-benefits" data-aos="fade-up">
                <div className="container">
                    <div className="benefits-grid mt-5">

                        <div className="benefit-card">
                            <div className="benefit-icon-box">
                                <FiEye className="benefit-icon" />
                            </div>

                            <h4>Real-time Visibility</h4>

                            <p>
                                Gain complete visibility into manufacturing operations with live insights
                                across every production stage.
                            </p>
                        </div>

                        <div className="benefit-card">
                            <div className="benefit-icon-box">
                                <FiAlertTriangle className="benefit-icon" />
                            </div>

                            <h4>Issue Detection</h4>

                            <p>
                                Detect production bottlenecks early and resolve operational challenges
                                before they impact output.
                            </p>
                        </div>

                        <div className="benefit-card">
                            <div className="benefit-icon-box">
                                <FiCheckSquare className="benefit-icon" />
                            </div>

                            <h4>Quality Improvement</h4>

                            <p>
                                Improve product quality with standardized workflows and continuous
                                monitoring.
                            </p>
                        </div>

                        <div className="benefit-card">
                            <div className="benefit-icon-box">
                                <FiSettings className="benefit-icon" />
                            </div>

                            <h4>Process Standardization</h4>

                            <p>
                                Maintain consistent manufacturing processes across multiple plants and
                                production lines.
                            </p>
                        </div>

                        <div className="benefit-card">
                            <div className="benefit-icon-box">
                                <FiBarChart2 className="benefit-icon" />
                            </div>

                            <h4>Data-driven Decisions</h4>

                            <p>
                                Use real-time analytics and performance insights to make smarter business
                                decisions.
                            </p>
                        </div>

                        <div className="benefit-card">
                            <div className="benefit-icon-box">
                                <FiTrendingUp className="benefit-icon" />
                            </div>

                            <h4>Plant Efficiency</h4>

                            <p>
                                Increase operational efficiency while reducing downtime and maximizing
                                productivity.
                            </p>
                        </div>

                    </div>
                </div>
            </section>


            <Approach
                title="Approach"
                data-aos="fade-up"
                backgroundImage={bg}
                items={approachItems}
            />

            <section className="container">
                <div className="man_services-section">
                    <h2 className="man_services-title" data-aos="fade-up">
                        Our services include:
                    </h2>

                    <div className="row">
                        <div className="col-md-6">
                            <ul className="man_services-list" data-aos="fade-right">
                                <li>Implementation of MES systems</li>
                                <li>Providing real-time visibility into plant floor operations</li>
                                <li>Integrating disparate manufacturing systems to extract valuable business data</li>
                            </ul>
                        </div>

                        <div className="col-md-6">
                            <ul className="man_services-list " data-aos="fade-left">
                                <li>Monitoring multiple manufacturing plants on a central platform</li>
                                <li>Supporting multi-location rollouts</li>
                                <li>Optimizing management and execution of production activities from order release to finished goods</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />


        </>
    );
};

export default Manufacturing;